import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';

const CurriculumLinkWrapper = styled.div((props) => {
    const { typography } = ThemeHelper.getTheme(props);

    return `
    font-family: ${typography.family};
    height: 100%;
    font-size: 14px;
    width: 100%
    `;
});

export default CurriculumLinkWrapper;



// WEBPACK FOOTER //
// ./app/components/curriculum-topic-link/styled.js